module.exports = "/assets/373f58c14caf7766bba44a2451a1ffb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9B.png
// module id = 2284
// module chunks = 0